import { Link } from 'react-router-dom';
import { categories } from '@/mocks/skincare';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  image: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
}

export default function ArticleCard({ slug, title, excerpt, category, image, author, date, readTime, tags }: ArticleCardProps) {
  const categoryName = categories.find((c) => c.slug === category)?.name || category;

  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative overflow-hidden aspect-[16/10]">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-5">
        <div className="flex items-center gap-2 mb-3 flex-wrap">
          <Link
            to={`/category/${category}`}
            className="text-xs px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 hover:bg-accent-200 transition-colors whitespace-nowrap"
          >
            {categoryName}
          </Link>
          <span className="text-xs text-foreground-400 whitespace-nowrap">{date}</span>
          <span className="text-xs text-foreground-400 whitespace-nowrap">{readTime}</span>
        </div>
        <Link to={`/article/${slug}`}>
          <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug" style={{ fontFamily: "var(--font-heading)" }}>
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 mb-3 line-clamp-2 leading-relaxed">
          {excerpt}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-500 whitespace-nowrap">{author}</span>
          <Link
            to={`/article/${slug}`}
            className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap flex items-center gap-1"
          >
            阅读更多
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}